import { fromJS } from 'immutable/dist/immutable';
import { isString } from '../../../../../form/formUtilities';

export const volcanoLocationSearchModel = fromJS({
  name: 'volcanoLocationSearchForm',
  initialValues: {
    minLongitude: '',
    maxLongitude: '',
    minLatitude: '',
    maxLatitude: '',
    country: '',
    morphology: '',
    status: '',
    timeErupt: '',
    region: '',
    id: '',
    newNum: '',
    num: '',
    volLocAssoc: '',
    minId: '',
    maxId: '',

    // Not in query model. Used for form radio selection.
    // Maps to:
    // - nameInclude
    // - nameMatch
    // - nameStart
    // - nameNot
    radios: {
      nameSearchType: 'nameInclude',
      name: '',
    },

  },
});

export const toSearchParameters = (model) => {
  const search = model.toJS();
  const { radios: { nameSearchType, name } } = search;
  if (nameSearchType) {
    search[nameSearchType] = name;
  }

  delete search.radios;


  Object.keys(search).forEach((key) => {
    let value = search[key];
    if (isString(value)) {
      value = value.trim();
      if (value) {
        search[key] = value;
      } else {
        delete search[key];
      }
    }
  });

  return search;
};
